import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { formateDate, showStatus } from "../../../../../utils/commonfunction";
import * as bannerServices from "../../../services/banner.services";
import { useTranslation } from "react-i18next";

const BannerView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Banners"), url: "/admin/cms/banner/list/1" },
        { title: t("View Banners"), url: "" },
    ];

    useEffect(() => {
        bannerServices
            .Details(params.id)
            .then((data) => {
                setShowDefault(data && data.data ? data.data : {});
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">{t("View Banners")}</h6>
                            </div>
                            {showdefault && Object.keys(showdefault)?.length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>
                                                <tr>
                                                    <th>{t("Banner Image")}</th>
                                                    <td>
                                                        {showdefault?.image ? (
                                                            <img src={showdefault.image} alt="Banner" style={{ maxHeight: '200px', borderRadius: '8px' }} />
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Title")} </th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.title ? showdefault.title : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Description")} </th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.description ? showdefault.description : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Redirect Type")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.redirect_type ? showdefault.redirect_type : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Redirect Item / URL")}</th>
                                                    <td>
                                                        {showdefault?.redirect_item_name ? (
                                                            <span className="badge bg-primary text-white p-2 fs-13">
                                                                {showdefault.redirect_type?.toUpperCase()}: {showdefault.redirect_item_name}
                                                            </span>
                                                        ) : showdefault?.url ? (
                                                            <a href={showdefault.url} target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-underline">
                                                                {showdefault.url}
                                                            </a>
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Status")}</th>
                                                    <td>
                                                        {toHtml(showStatus(showdefault.status ?? 0))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Created Date")}</th>
                                                    <td>
                                                        {showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Modified Date")}</th>
                                                    <td>
                                                        {showdefault.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="mt-5">
                                            <button
                                                className="btn ripple btn-dark"
                                                type="button"
                                                onClick={() => navigate(-1)}
                                            >
                                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                                {t("btn_back")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Loader />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BannerView;
